import { useEffect, useState } from "react";
export const usePortal = (portalName) => {
    const [portalContainer, setPortalContainer] = useState(null);
    useEffect(() => {
        const el = document.querySelector(`[data-portal="${portalName}"]`);
        if (!el) {
            console.error(`No portal container found [data-portal="${portalName}"]`);
            return;
        }
        setPortalContainer(el);
    }, [portalName]);
    return portalContainer;
};
//# sourceMappingURL=usePortal.js.map